import React, {Component} from 'react';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import PropTypes from 'prop-types';
import {withStyles} from 'material-ui/styles';
import styles from './style/styles';
import TableReviewsAllocation from './forms/TableReviewsAllocation';
import ConfigurationTabs from '../configuration/ConfigurationTabs';
import {setConfigurationTab} from '../layout/actions';
import {changeSiteLanguage} from './actions';
import {showSideMenuConfiguration} from '../../components/permissions/permissions';
import ScrollToTop from '../../components/scroll-top/ScrollToTop';
import {fetchSites} from '../sites/thunks';
import {fetchLanguages} from '../languages/thunks';
import {
    fetchSitesLanguages,
    updateSitesLanguages
} from './thunks';

class Configuration extends Component {

    componentWillUnmount() {
        toastr.removeByType('error');
    }

    onConfigurationGridMount() {
        this.props.fetchSites();
        this.props.fetchLanguages();
        this.props.fetchSitesLanguages();
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.sitesLanguages !== null &&
            nextProps.sites.length > 0 &&
            nextProps.languages.length > 0;
    }

    handleReviewsSubmit(e) {
        e.preventDefault();
        this.props.updateSitesLanguages(this.props.sitesLanguages);
    }

    render() {

        return (
            <div>
                <ConfigurationTabs
                    activeTab={this.props.activeConfigurationTab}
                    onChange={(event, value) => {
                        this.props.setConfigurationTab(value);
                    }}
                />

                {this.props.activeConfigurationTab === 0 && this.props.sites &&
                    <TableReviewsAllocation
                        handleSubmit={this.handleReviewsSubmit.bind(this)}
                        mountConfigurationGrid={this.onConfigurationGridMount.bind(this)}
                        sites={this.props.sites}
                        languages={this.props.languages}
                        sitesLanguages={this.props.sitesLanguages}
                        changeSiteLanguage={this.props.changeSiteLanguage}
                        classes={this.props.classes}
                        loading={this.props.loading}
                        touched={this.props.touched}
                    />
                }

                <ScrollToTop />
            </div>
        )
    }
}

Configuration.propTypes = {
    classes: PropTypes.object,
    handleSubmit: PropTypes.func,
    mountConfigurationGrid: PropTypes.func,
    sites: PropTypes.array.isRequired,
    languages: PropTypes.array.isRequired,
    sitesLanguages: PropTypes.array.isRequired,
    changeSiteLanguage: PropTypes.func.isRequired,
    loading: PropTypes.bool,
};

const mapStateToProps = state => ({
    activeConfigurationTab: state.layout.activeConfigurationTab,
    sites: state.sites.all,
    languages: state.languages.all,
    sitesLanguages: state.configuration.sitesLanguages,
    loading: state.layout.ajaxCallsInProgress > 0,
    touched: state.configuration.touched,
});

export default connect(mapStateToProps, {
    setConfigurationTab,
    fetchLanguages,
    fetchSites,
    fetchSitesLanguages,
    updateSitesLanguages,
    changeSiteLanguage
})(withStyles(styles)(showSideMenuConfiguration(Configuration)));


// WEBPACK FOOTER //
// ./src/containers/configuration/index.js